import { render, staticRenderFns } from "./sbAdd.vue?vue&type=template&id=04e48417&scoped=true"
import script from "./sbAdd.vue?vue&type=script&lang=js"
export * from "./sbAdd.vue?vue&type=script&lang=js"
import style0 from "./sbAdd.vue?vue&type=style&index=0&id=04e48417&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e48417",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e48417')) {
      api.createRecord('04e48417', component.options)
    } else {
      api.reload('04e48417', component.options)
    }
    module.hot.accept("./sbAdd.vue?vue&type=template&id=04e48417&scoped=true", function () {
      api.rerender('04e48417', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/sbAdd.vue"
export default component.exports